









































































import { Component, Prop, Vue } from 'vue-property-decorator';

const defaultExhibitionInfos: any[] = [{
  ID: '01',
  TITLE: '宁波登越新加广交会1',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}, {
  ID: '02',
  TITLE: '宁波登越新材料科技有限公司参加广交司参加广交司参加广交会2',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}, {
  ID: '03',
  TITLE: '宁波登越新材料科技有限公司参加广交会3',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}, {
  ID: '04',
  TITLE: '宁波登越新材料科技有限公司参加广交会4',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}, {
  ID: '05',
  TITLE: '宁波登越新材料科技有限公司参加广交会5',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}, {
  ID: '06',
  TITLE: '宁波登越新材料科技有限公司参加广交会6',
  SHOWTIME: '2018/11/08 00:00:00',
  href: '#',
}];

@Component
export default class Threenews extends Vue {
  /**
   * 展会信息数组，用于渲染数据，例子
   * [{title: '宁波登越新材料科技有限公司参加广交会现场  2018-10-30', href: '#'}]
   */
  @Prop({ default: () => defaultExhibitionInfos })
  private exhibitionInfos!: any[];
  /**
   * 检查报告数组，用于渲染数据，例子
   * [{title: '宁波登越新材料科技有限公司参加广交会现场  2018-10-30', href: '#'}]
   */
  @Prop({ default: () => defaultExhibitionInfos })
  private reportInfos!: any[];
  /**
   * 相关资料数组，用于渲染数据，例子
   * [{title: '宁波登越新材料科技有限公司参加广交会现场  2018-10-30', href: '#'}]
   */
  @Prop({ default: () => defaultExhibitionInfos })
  private dataInfos!: any[];
}
